var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShkarkuarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "#1d3943",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "no_accounts_FILL1_wght400_GRAD0_opsz48",
    d: "M29.4,22.9l-9.75-9.75a9.456,9.456,0,0,1,1.975-.95A7.036,7.036,0,0,1,24,11.8a6.746,6.746,0,0,1,6.85,6.85,8.412,8.412,0,0,1-.375,2.475A3.477,3.477,0,0,1,29.4,22.9ZM11.2,35.35a34.313,34.313,0,0,1,6.125-3.05A19.139,19.139,0,0,1,24,31.2a21.746,21.746,0,0,1,3.525.275,17.228,17.228,0,0,1,2.825.675l-6.7-6.7a6.235,6.235,0,0,1-6.35-6.1l-6.4-6.4a17.46,17.46,0,0,0-2.875,4.975A17.143,17.143,0,0,0,7,24a17.262,17.262,0,0,0,1,5.85A18.722,18.722,0,0,0,11.2,35.35Zm26-.35a16.362,16.362,0,0,0,2.775-4.9A17.617,17.617,0,0,0,41,24q0-7.6-4.7-12.3T24,7a17.022,17.022,0,0,0-6.2,1.05A17.848,17.848,0,0,0,13,10.8ZM24,44A19.84,19.84,0,0,1,4,24,19.84,19.84,0,0,1,24,4,19.84,19.84,0,0,1,44,24,19.84,19.84,0,0,1,24,44Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShkarkuarIcon);
export default __webpack_public_path__ + "static/media/shkarkuar_icon.e5cf8f34c51f634a2771540d8f959d85.svg";
export { ForwardRef as ReactComponent };